import { useEffect, useState } from 'react';
import { useSearch } from '../contexts/SearchContext';

/**
 * Filtro de página (ej. modelo) que se aplica al pulsar "Aplicar filtros".
 */
export function useExtraTableFilter(initialValue = '') {
  const { registerExtraFilterApply, registerExtraFilterClear } = useSearch();
  const [draft, setDraft] = useState(initialValue);
  const [applied, setApplied] = useState(initialValue);

  useEffect(() => {
    const unregisterApply = registerExtraFilterApply(() => {
      setApplied(draft);
    });
    const unregisterClear = registerExtraFilterClear(() => {
      setDraft(initialValue);
      setApplied(initialValue);
    });
    return () => {
      unregisterApply();
      unregisterClear();
    };
  }, [
    draft,
    initialValue,
    registerExtraFilterApply,
    registerExtraFilterClear,
  ]);

  return { draft, setDraft, applied };
}
